import CustomSelect from "../../../components/FormComponents/CustomSelect";
import When from "../../../components/When";
import FormProvider from "./FormProvider/FormProvider";

const ValueToText = (value?: boolean) => {
    if (value === undefined) return "Ej angivet";
    return value ? 'Ja' : 'Nej';
}
type BooleanFormProps = { editMode: boolean, header: string, propertyName: string, property?: boolean, onChange: (value: boolean | null, e: any) => void };

export function BooleanForm(props: BooleanFormProps) {
    return <FormProvider controlId={"form" + props.propertyName} title={props.header}>
        <When condition={props.editMode}
              otherwise={<span data-test-id={"form" + props.propertyName}>{ValueToText(props.property)}</span>}>
            <CustomSelect
                isEditMode={props.editMode}
                name={props.propertyName}
                value={props.property === undefined ? '' : props.property ? '1' : '0'}
                options={<>
                    <option value="">Ej angivet</option>
                    <option value="1">Ja</option>
                    <option value="0">Nej</option>
                </>}
                onChange={e => {
                    let value = null;
                    if (e.target.value) {
                        value = e.target.value === '1';
                    }
                    props.onChange(value, e);
                }}
            />
        </When>
    </FormProvider>
}